import { NgModule } from '@angular/core'
import { SharedModule } from '../shared/shared.module'

import { LayoutLoginComponent } from './Login/login.component'
import { LayoutMainComponent } from './Main/main.component'
import { LayoutPublicComponent } from './Public/public.component'
import { LayoutModule } from '../core/components/LayoutComponents/layout.module'

const COMPONENTS = [LayoutLoginComponent, LayoutMainComponent, LayoutPublicComponent]

@NgModule({
  imports: [SharedModule, LayoutModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class LayoutsModule {}
